<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="650px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    append-to-body
    class="grid-view"
    @close="onCancel"
  >
    <div class="tabs-container">
      <el-tabs :active-name="activeTabName" @tab-click="handleClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_ApplicationForm')" name="applicationForm">
          <el-form :inline="true" style="width: 100%" label-width="75px" label-position="left" :disabled="action === 'look'">
            <div style="display: flex;flex-direction: row;">
              <div style="padding-top: 10px">
                <el-form-item :label="$t('CargoMsg.Cargo_TaxRate')">
                  <el-input-number
                    v-model="pay.taxRate"
                    controls-position="right"
                    style="width: 200px;"
                    :max="999.000000"
                    :min="0.000000"
                    :precision="2"
                  />
                </el-form-item>
                <el-form-item :label="$t('Invoice.invoice_invoiceCategory')">
                  <el-select v-model="pay.invoiceType" clearable style="width: 200px">
                    <el-option
                      v-for="(item,index) in invoiceMakeTypes"
                      :key="index"
                      :label="item.chineseName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_Priority')">
                  <el-select v-model="pay.priority" clearable style="width: 200px">
                    <el-option
                      v-for="(item,index) in priorityTypes"
                      :key="index"
                      :label="item.chineseName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item :label="' '" class="dense-radio-group">
                  <el-checkbox-group v-model="prepayList" style="margin-left:10px;" :max="1" @change="prepayChange">
                    <el-checkbox :label="1">{{ $t('CargoMsg.Cargo_Prepaid') }}</el-checkbox>
                    <el-checkbox :label="2">{{ $t('CargoMsg.Cargo_Collection') }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.remarks')" label-width="100px">
                  <el-input v-model="pay.remark" type="textarea" :rows="6" style="width:240px;" />
                </el-form-item>
              </div>
            </div>
            <div v-if="'add' !== action">
              <el-form-item :label="$t('CargoMsg.Cargo_ReceiveMethod')">
                <el-select
                  v-model="pay.receiveType"
                  style="width: 200px"
                >
                  <el-option
                    v-for="(item,index) in receiveTypes"
                    :key="index"
                    :label="$store.getters.isZh ? item.chineseName : item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_AccountToBeCredited')" label-width="95px">
                <el-input v-model="pay.receiveAccount" style="width: 240px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_ReceivingBank')">
                <el-select
                  v-model="recipientBankUuid"
                  style="width: 200px"
                  @change="recipientBankChange"
                >
                  <el-option
                    v-for="(item,index) in receivingBanks"
                    :key="index"
                    :label="item.currency + '-' + item.bank"
                    :value="item.uuid"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_BankConnectionNo2')" label-width="95px">
                <el-input v-model="pay.swiftCode" style="width: 240px" />
              </el-form-item>
            </div>
          </el-form>
          <div v-if="'add' !== action">
            <cargo-ag-grid
              config-module="190805"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;height:100%;flex-grow: 1"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="pay.uuid"
          :label="$t('CargoMsg.Cargo_FileHistory')"
          name="fileHistory"
          :lazy="true"
          style="height: 509px;"
        >
          <file-history
            :uuid="pay.uuid"
            :state="pay.apState"
            module-name="billPayment"
            :input-by="$store.getters.userId"
            grid-height="460px"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <hr>
    <div style="margin-bottom: 10px; display: flex; float:right">
      <el-button v-if="['add','edit'].includes(action)" type="primary" @click="onSubmit">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import fileHistory from '@/views/cargo/v0/Clearing/components/BillPayment/fileHistory'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { apDetailFunc, saveApFunc, titleBankFunc, updateSaveApFunc } from '@/api/act/financeAp'
import { FinanceAp } from '@/class/model/act/FinanceAp'
import { AMOUNT_RECEIVE_TYPES } from '@/class/cargo/model/parameters/ClearingConstants'

export default {
  name: 'PayableDetailDialog',
  components: { CargoDialog, fileHistory, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    action: { type: String, required: false, default: 'add' },
    mergeType: { type: Boolean, required: false, default: false },
    uuids: { type: Array, required: false, default: () => [] },
    title: { type: String, required: false, default: '' }
  },
  data() {
    return {
      activeTabName: 'applicationForm', // 当前展示页签
      innerVisible: false,
      receiveTypes: AMOUNT_RECEIVE_TYPES, // 收付方式源
      fullscreenLoading: null,
      gridParams: {},
      gridApi: {},
      rowData: [],
      SystemConstants: SystemConstants,
      prepayList: [],
      pay: new FinanceAp().fillDefaultValue().getData(),
      receivingBanks: [],
      recipientBankUuid: null,
      gridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          filter: false
        }
      }
    }
  },
  computed: {
    invoiceMakeTypes() {
      return SystemConstants.FINANCE_AP_INVOICE_TYPE
    },
    priorityTypes() {
      return SystemConstants.PRIORITY_TYPE
    },
    columnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_DetailEntryID'), field: 'detailNo', width: 100 },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'lob', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_IncludedTaxAmount'), field: 'amount', width: 100 }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    recipientBankChange(uuid) {
      const bank = this.receivingBanks.find(p => p.uuid === uuid)
      if (bank) {
        this.pay.receiveAccount = bank.bankAccount
        if (bank.paymentLine) {
          this.pay.swiftCode = bank.paymentLine
        } else {
          this.pay.swiftCode = bank.swiftCode
        }
        this.pay.recipientBank = bank.bank
        this.pay.bankCurrency = bank.currency
      }
    },
    // 显示下之前选的收款银行
    showBank() {
      const bank = this.receivingBanks.find(p => p.currency === this.pay.bankCurrency && p.bank === this.pay.recipientBank)
      if (bank) {
        this.recipientBankUuid = bank.uuid
      }
    },
    async onShow(data) {
      if (data.uuid) {
        apDetailFunc({ 'uuid': data.uuid }).then(async res => {
          this.pay = res.data
          if (this.pay.prepay !== 0) {
            this.prepayList = [this.pay.prepay]
          }
          this.rowData = res.data.voList
          if (this.pay.invoiceTitle) {
            const res = await titleBankFunc({ 'title': this.pay.invoiceTitle })
            if (res && res.data) {
              this.receivingBanks = res.data
              this.showBank()
            }
          }
        })
      }
    },
    // 保存应付单
    onSubmit() {
      if (!this.uuids) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAp'))
        return
      }
      if (!this.pay.invoiceType) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectInvoiceType'))
        return
      }
      const formData = {}
      formData.action = this.action
      formData.branchId = this.$store.getters.currentOfficeId
      formData.mergeType = this.mergeType
      formData.taxRate = this.pay.taxRate
      formData.priority = this.pay.priority
      formData.prepay = this.pay.prepay
      formData.invoiceType = this.pay.invoiceType
      formData.remark = this.pay.remark
      formData.receiveType = this.pay.receiveType
      formData.receiveAccount = this.pay.receiveAccount
      formData.recipientBank = this.pay.recipientBank
      formData.swiftCode = this.pay.swiftCode
      formData.bankCurrency = this.pay.bankCurrency
      formData.uuidList = this.uuids
      this.fullscreenLoading = getLoading()
      const doFunc = this.action === 'add' ? saveApFunc : updateSaveApFunc
      doFunc(formData).then(res => {
        if (res.data) {
          if (res.data === 'ok') {
            this.saveResultHandler()
          } else if (SystemConstants.asyncMapping_1.code === res.data || SystemConstants.asyncMapping_2.code === res.data) {
            this.$message.success(ColumnUtils.showTypeLabelFunc(res.data, SystemConstants.ASYNC_MAPPING_TYPE))
            this.saveResultHandler()
          } else {
            this.$message.warning(ColumnUtils.showTypeLabelFunc(res.data, SystemConstants.ERROR_MAPPING_TYPE))
          }
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    prepayChange() {
      if (this.prepayList.length > 0) {
        this.pay.prepay = this.prepayList[0]
      } else {
        this.pay.prepay = 0
      }
    },
    handleClick(tab, event) {
      this.activeTabName = tab.name
    },
    saveResultHandler() {
      this.innerVisible = false
      this.$emit('saveResult')
    },
    onCancel() {
      this.innerVisible = false
    }
  }
}
</script>

<style scoped>

</style>
